import PostMessageParser from 'services/AuthSuite/AuthSuiteServices/messaging-service/PostMessageParser';
import loginEvent from 'services/AuthSuite/AuthSuiteServices/events/login-event';

export default class AuthSuiteMessagingService {
    constructor() {
        this.postMessageParser = new PostMessageParser();
        this.loginEvent = loginEvent;
    }

    /**
     * Listen to post messaging and trigger event if successful login event comes from
     * auth suite popup-blank-page
     *
     * @returns {undefined} void
     */
    registerPostLoginMessaging = () => {
        if (typeof window !== 'undefined') {
            window.addEventListener('message', (event) => {
                const code = this.postMessageParser.parse(event.data);
                if (code) {
                    this.broadcastSuccessGetAuthCode(code);
                }
            });
        }
    };

    /**
     * Broadcasts successful login event
     *
     * @param {string} authorizationCode - authorization code received from the provider
     *
     * @returns {undefined} void
     */
    broadcastSuccessGetAuthCode = (authorizationCode) => {
        if (authorizationCode) {
            this.loginEvent.emitSuccess(authorizationCode);
        }
    };
}
